import React, {useState} from 'react';
import './App.css';
import {CssBaseline, Box, ThemeProvider} from '@mui/material';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import {FileProvider} from './context/FileContext';
import {ToastContainer} from 'react-toastify';
import {useThemeContextBuilder, themeContext} from 'theme/ThemeContext';
import LoginPage from 'components/login/LoginPage';
import {Footer} from 'components/Footer';
import {useAuthContext} from 'context/AuthContext';
import {NotificationProvider} from 'components/notifications/NotificationContext';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';

const App: React.FC = () => {
   const stateTheme = useThemeContextBuilder();
   const {theme} = stateTheme;
   const {isAuth} = useAuthContext();

   return (
      <ThemeProvider theme={theme}>
         <CssBaseline />
         <themeContext.Provider value={stateTheme}>
            <NotificationProvider>
               <ToastContainer
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
               />
               {isAuth ? (
                  <Box
                     sx={{
                        display: 'flex',
                        flexFlow: 'column nowrap',
                        marginLeft: '0rem',
                        minHeight: '100vh',
                     }}
                  >
                     <FileProvider>
                        <Navbar />
                        {/* <Sidebar /> */}
                        <Box component="main" sx={{flexGrow: 1, p: 3}}>
                           <DndProvider backend={HTML5Backend}>
                              <Home />
                           </DndProvider>
                        </Box>
                        <Footer />
                     </FileProvider>
                  </Box>
               ) : (
                  <LoginPage />
               )}
            </NotificationProvider>
         </themeContext.Provider>
      </ThemeProvider>
   );
};

export default App;
